var map = {
	"./eight.png": 1241,
	"./five.png": 7595,
	"./four.png": 6932,
	"./nine.png": 3734,
	"./one.png": 7317,
	"./seven.png": 607,
	"./six.png": 4233,
	"./three.png": 268,
	"./two.png": 84
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1868;